import type { StateCreator, StoreApi } from "zustand";

// eslint-disable-next-line replo/no-zustand-create-or-usestore -- this is the wrapper itself
import { useStore } from "zustand";
import { useShallow } from "zustand/react/shallow";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

/**
 * Drop-in replacement for zustand's `useStore` that uses shallow equality by default.
 * Use this in context-based stores so all selectors automatically get shallow comparison.
 */
export function useShallowStore<StateType, SelectedType>(
  store: StoreApi<StateType>,
  selector: (state: StateType) => SelectedType,
): SelectedType {
  return useStore(store, useShallow(selector));
}

/**
 * Drop-in replacement for zustand's `create` that uses shallow equality by default.
 * Use this instead of `create()` so all selectors automatically get shallow comparison.
 */
export function createShallowStore<StateType>(
  initializer: StateCreator<StateType, [], []>,
) {
  return createWithEqualityFn<StateType>(initializer, shallow);
}
